module.exports = __webpack_public_path__ + "static/media/redo_urgent.47078797.svg";